
export default {
  name: 'LoadingContainer',
  props: {
    pending: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Loading...'
    }
  }
}
